function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { fabric } from "fabric";
import { consumeContext } from "../PlayerContext";
import { scalableCanvas, fourDimensionalCanvas } from "../../Misc/CanvasDecorators";
var EMPTY_OVERLAY = '{"version":"2.4.4","objects":[]}';

var Poster = function (_React$Component) {
  _inherits(Poster, _React$Component);

  function Poster() {
    var _temp, _this, _ret;

    _classCallCheck(this, Poster);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.initializeCanvas = function (canvas) {
      if (_this.canvas) {
        return;
      }

      _this.canvas = fourDimensionalCanvas(scalableCanvas(new fabric.StaticCanvas(canvas)));
      var PlayerContext = _this.props.PlayerContext;
      var overlay = PlayerContext.state.overlay;

      _this.canvas.loadFromJSON(overlay || EMPTY_OVERLAY, function () {
        _this.canvasContentLoaded = true;

        _this.refreshCanvas();

        PlayerContext.reportOverlayLoaded();
      });
    }, _this.refreshCanvas = function () {
      var PlayerContext = _this.props.PlayerContext;
      var _PlayerContext$state = PlayerContext.state,
          videoState = _PlayerContext$state.videoState,
          scale = _PlayerContext$state.scale;

      if (videoState && videoState.readyState !== 0 && !_this.canvasSizeInitialized) {
        _this.canvasSizeInitialized = true;

        _this.canvas.setWidth(videoState.videoWidth);

        _this.canvas.setHeight(videoState.videoHeight);
      }

      if (scale > 0 && _this.canvasSizeInitialized && _this.canvasContentLoaded) {
        _this.canvas.scale(scale);
      }

      if (videoState) {
        _this.canvas.alignToTime(videoState.currentTime);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Poster.prototype.componentDidUpdate = function componentDidUpdate() {
    this.refreshCanvas();
  };

  Poster.prototype.render = function render() {
    return React.createElement("canvas", {
      ref: this.initializeCanvas,
      style: {
        position: "relative"
      }
    });
  };

  return Poster;
}(React.Component);

Poster.propTypes = process.env.NODE_ENV !== "production" ? {
  PlayerContext: PropTypes.object.isRequired
} : {};
export default consumeContext(Poster);